import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgentLanguages } from './api';
import { useParams } from 'react-router-dom';
import { AgentLanguagesResponse } from './types';

export function useGetAgentLanguages(options?: UseQueryOptions<AgentLanguagesResponse, Error>) {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();
  return useQuery<AgentLanguagesResponse>({
    queryKey: ['agency_languages', locationId, agentId],
    queryFn: () => getAgentLanguages(locationId, agentId),
    enabled: Boolean(locationId && agentId),
    ...options
  });
}
